import def from "./def";

export default function Icon({ name, size='16px', ...props }) {
	const Cmp = def[name];
	if (!Cmp) return null;
	const p = {...props};
	if (size) {
		p.width = size;
		p.height = size;
	}
	return <Cmp {...p} />;
}